import React, {useState} from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";
import layoutStyle from "assets/jss/material-kit-react/components/layoutStyle";
import {useTranslation } from 'gatsby-plugin-react-i18next';
import Api from '../../lib/api';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import ExitToApp from "@material-ui/icons/ExitToApp";
import ArrowBack from "@material-ui/icons/ArrowBack";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Slide from "@material-ui/core/Slide";
import { navigate } from "gatsby";
import queryString from 'query-string';
import Helper from '../../lib/helper';

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

const LayoutMain = ({ ...props }) => {
  const {t} = useTranslation('layout');
  const { classes, children, isLoading } = props;
  const [showQuit, setShowQuit] = useState(false);

  const imageClasses = classNames(
    classes.imgFluid
  );

  let fromPage = '';
  if(Helper.isNotNullAndUndefined(props.location) && Helper.stringIsNotEmpty(props.location.search)) {
    let params = queryString.parse(props.location.search)
    fromPage = Helper.stringIsNotEmpty(params.from) ? params.from : '';
  }

  return (
    <>
      {
        isLoading &&
        <div className={classes.loading}>
          <img
            src={require('../../assets/img/loading.svg')} alt={'Loading'}
          />
          <span className={classes.loadingText}>{t('loading')}</span>
        </div>
      }
      <div>
        <GridContainer justify="center" className={classNames(classes.main, classes.mainRaised)}>
          <GridItem className={classes.header}>
            <div className={classes.logoSmall}>
              <img src={require('../../assets/img/logo_w_text.png')} alt={'Logo'} className={imageClasses}  />
            </div>
            <div style={{position: 'absolute', right: 4}}>
              <Button simple className={classes.activeSimpleButton} 
                style={{fontSize: "0.9em", padding: 4, marginLeft: 10}}
                onClick={_ => {
                  if(fromPage.toLowerCase() === 'module') {
                    navigate('/module');
                  }
                  else
                    setShowQuit(true);
                }}  
              >
                {t(fromPage.toLowerCase() === 'module' ? 'header.back' : '')} 
                {
                  fromPage.toLowerCase() === 'module' ?
                  <ArrowBack style={{marginLeft: 6}}/>
                  :
                  '' // <ExitToApp style={{marginLeft: 6}}/>
                }
              </Button>
            </div>
          </GridItem>
          <GridItem className={classes.content}>
            {children}
          </GridItem>
        </GridContainer>
      </div>
      {/* Quit App Dialog */}
      <Dialog
        classes={{
          root: classes.center,
          paper: classes.modal
        }}
        open={showQuit}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {setShowQuit(false)}}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <div className={classNames(classes.modalTitle, classes.alertDlgTitle)}>{t('dialog.quit.title')}</div>
        </DialogTitle>
        <DialogContent
          id="classic-modal-slide-description"
          className={classes.modalBody}
        >
          <p className={classes.alertDlgBody}>
            {t('dialog.quit.desc')}
          </p>
        </DialogContent>
        <DialogActions className={classes.modalFooter} style={{justifyContent: 'center'}}>
          <Button
            onClick={() => {
              setShowQuit(false);
            }}
            className={classes.normalButton}
          >
            {t('dialog.logout.cancel')}
          </Button>
          <Button
            onClick={() => {
              setShowQuit(false);
              Api.posQuitApp()
              .catch(err => {});
            }}
            className={classes.alertButton}
          >
            {t('dialog.logout.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

LayoutMain.defaultProps = {
  isLoading: false
};

LayoutMain.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  isLoading: PropTypes.bool
};

LayoutMain.contentSize = {
  width: layoutStyle.content.minWidth,
  height: layoutStyle.content.minHeight,
}

export default withStyles(layoutStyle)(LayoutMain);